import { createFeature, createReducer, on } from '@ngrx/store';
import { TranslationsActions } from '../actions/translations.actions';
import { ErrorStore, Translation } from '@sleipai/sleip-models';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export const translationsStoreFeatureKey = 'translations';

export interface State extends EntityState<Translation> {
  loaded: boolean;
  loading: boolean;
  error: ErrorStore | null;
}

export const adapter: EntityAdapter<Translation> =
  createEntityAdapter<Translation>();

export const initialState: State = adapter.getInitialState({
  loading: false,
  loaded: false,
  error: null,
});

export const reducer = createReducer(
  initialState,
  on(TranslationsActions.loadTranslationbyType, (state) => {
    return {
      ...state,
      loading: true,
      error: null,
    };
  }),
  on(TranslationsActions.translationLoadedSuccess, (state, { translation }) =>
    adapter.upsertOne(translation, {
      ...state,
      loaded: true,
      loading: false,
    })
  ),
  on(TranslationsActions.translationLoadedFailure, (state, { error }) => {
    return {
      ...state,
      loaded: true,
      loading: false,
      error: {
        message: error['message'],
        status: error['status'],
      },
    };
  })
);

export const translationsStoreFeature = createFeature({
  name: translationsStoreFeatureKey,
  reducer,
});

export const {
  selectIds: selectTranslationsEntitiesIdsAdapter,
  selectEntities: selectTranslationsEntitiesAdapter,
  selectAll: selectAllTranslationsAdapter,
  selectTotal: selectTranslationsTotalAdapter,
} = adapter.getSelectors();